import { FC } from 'react';

export const Grip: FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M8 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M8 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M14 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M14 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M14 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  </svg>
);

export default Grip;
